/* eslint-disable react/jsx-handler-names */

import { useTranslation } from 'react-i18next';

export default function SomethingWentWrong() {
  const { t } = useTranslation();
  return (
    <div
      className="fixed inset-0 z-10 flex h-screen w-screen items-center justify-center"
      style={{
        backdropFilter: 'blur(4px)',
        backgroundColor: 'rgba(0, 47, 118, 0.85)',
      }}
    >
      <dialog
        open
        className="relative flex min-h-[350px] w-[90%] max-w-[500px] flex-col items-center justify-center rounded-[16px] bg-white p-6 text-center shadow-lg"
      >
        <p className="mb-4 text-3xl font-semibold text-primary-blue-3">{t('somethingWentWrong')}</p>
        <p className="mb-8 text-lg text-gray-600">{t('reloadPage')}</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="w-1/2 rounded-full bg-primary-yellow-3 px-6 py-3 text-lg font-semibold text-primary-blue-3 shadow-md transition-all duration-300 hover:bg-primary-yellow-4"
        >
          {t('reload')}
        </button>
      </dialog>
    </div>
  );
}
